import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { formatDate } from 'date-fns';
import { CellChipComponent, CellTooltipComponent, TableActionsComponent } from 'shared/components/molecules';
import { DATE_FORMATS } from 'shared/constants/date.const';
import { DateColumnWithOffsetComponent } from '../components/molecules/data-table/date-column-with-offset/date-column-with-offset.component';

export class TableColumnDefinitions {
  private static defaultMaxWidth = 201;

  private static globalSettings: Partial<ColDef> = {
    sortable: true,
    cellRenderer: CellTooltipComponent,
  };

  public static actionsColumn<T>(colDef: ColDef): ColDef {
    colDef = {
      field: 'actions',
      ...this.globalSettings,
      ...colDef,
      headerClass: 'central-header',
      cellClass: 'actions-cell',
      cellRenderer: TableActionsComponent<T>,
      resizable: false,
      sortable: false,
      suppressAutoSize: true,
      suppressSizeToFit: true,
    };

    return colDef;
  }

  public static dateColumn(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      ...colDef,
      cellRenderer: DateColumnWithOffsetComponent,
      valueFormatter: (params) => {
        if (params.value) {
          return formatDate(new Date(params.value), DATE_FORMATS.AM_PM);
        }
        return '';
      },
    };
  }

  public static fitToContent(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      ...colDef,
    };
  }

  public static fitToContentCenter(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      ...colDef,
      headerClass: 'central-header',
      cellStyle: { textAlign: 'center' },
    };
  }

  public static temperature(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      ...colDef,
      headerClass: 'central-header',
      cellStyle: { textAlign: 'center' },
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value == undefined || params.value == null || !params.data) {
          return '';
        }

        let unit = params.data[colDef.field + 'Unit'];

        // TODO: firefly-1-9758-ui clean up after merge flag expires
        const oldFormat = params.data[colDef.field + 'WithUnit'];
        if (oldFormat) {
          unit = oldFormat?.slice(-1);
        }
        if (!unit) {
          unit = 'F';
        }

        return `<div>${params.value} ${unit}</div>`;
      },
    };
  }

  public static chip(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      ...colDef,
      cellRenderer: CellChipComponent,
    };
  }

  public static maxWidth(colDef: ColDef): ColDef {
    return {
      ...this.globalSettings,
      maxWidth: this.defaultMaxWidth,
      ...colDef,
    };
  }

  public static flex(colDef: ColDef): ColDef {
    return {
      flex: 1,
      ...this.globalSettings,
      ...colDef,
    };
  }
}
